import { render, staticRenderFns } from "./StickerSet.vue?vue&type=template&id=163be8f1&"
import script from "./StickerSet.vue?vue&type=script&lang=js&"
export * from "./StickerSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports